import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import InquirySidebar from "../components/InquirySidebar";

const ComingSoonPage = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden text-white font-sans">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="/assets/hero.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Navbar */}
      <nav className="fixed w-full z-50 px-4 sm:px-6 md:px-12 py-5 mt-3 flex justify-between items-center">
        <img
          src="/assets/LOGO.png"
          alt="Edge Pixel Logo"
          className="h-5 sm:h-8 md:h-6 lg:h-8 object-contain"
        />
        <button className="text-white text-4xl">☰</button>
      </nav>

      {/* Hero Section */}
      <section className="relative w-full overflow-hidden h-screen">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover"
        >
          <source src="/assets/Hero.mp4" type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-black/60 z-10 flex justify-between items-center pl-4 pr-12 sm:pl-6 sm:pr-20 md:pl-12 md:pr-32">
          <div className="flex flex-col justify-center h-[112px] sm:h-[128px] lg:h-[160px]">
            <h1 className="max-w-[1000px] text-[18px] sm:text-[26px] md:text-[30px] lg:text-[34px] xl:text-[42px] font-thin font-montserrat mb-2 sm:mb-1 leading-tight tracking-wide text-white break-words">
              <span className="block sm:inline">
                Our website is currently
              </span>{" "}
              <span className="block sm:inline">
                under development. Follow us for  updates
              </span>{" "}
              <span className="block sm:inline">
              and launch news!
              </span>
            </h1>
          </div>
        </div>
      </section>

      {/* Social Icons */}
      <div className="absolute bottom-10 left-4 sm:left-6 md:left-12 z-20">
        <span className="text-sm block mb-2">Stay in touch with us</span>
        <div className="flex flex-wrap gap-3 text-gray-300 max-w-[200px]">
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="hover:text-white text-lg" />
          </a>
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF className="hover:text-white text-lg" />
          </a>
          <a
            href="https://twitter.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter className="hover:text-white text-lg" />
          </a>
          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="hover:text-white text-lg" />
          </a>
          <a
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube className="hover:text-white text-lg" />
          </a>
        </div>
      </div>

      {/* Inquiry Sidebar */}
      <InquirySidebar isSidebarOpen={false} />
    </div>
  );
};

export default ComingSoonPage;
